import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import CreateDashboardClient from 'use-case/dashboard/create/createDashboardClient';
import CreateDashboardCriteria from 'use-case/dashboard/create/createDashboardCriteria';
import BasicEntity from 'domain/entity/basicEntity';

export default (httpClient: httpClientFunction, baseUrl: string): CreateDashboardClient => (criteria: CreateDashboardCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards`, {
        method: 'POST',
        body: JSON.stringify(asNewDashboardJson(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then((json: BasicEntity) => ({ id: json.id }))
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asNewDashboardJson = (criteria: CreateDashboardCriteria): NewDashboardJson => ({
    name: criteria.name,
    type: criteria.type,
    description: criteria.description,
});

type NewDashboardJson = {
    name: string;
    type: string;
    description: string;
};
